export default __webpack_public_path__ + "static/media/washer.3899a81f.svg";